import { CloseIcon } from '@atgfr8/icons';
import { Component, JSX, Show } from 'solid-js';

export interface GlassModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  children: JSX.Element;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  showCloseButton?: boolean;
  closeOnBackdropClick?: boolean;
}

const GlassModal: Component<GlassModalProps> = (props) => {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
  };

  const handleBackdropClick = (): void => {
    if (props.closeOnBackdropClick !== false) {
      props.onClose();
    }
  };

  const handleModalClick = (e: MouseEvent): void => {
    e.stopPropagation();
  };

  return (
    <Show when={props.isOpen}>
      <div
        class="fixed inset-0 z-50 flex items-center justify-center p-2 animate-in fade-in duration-300"
        onClick={handleBackdropClick}
      >
        <div
          class="absolute inset-0 backdrop-blur-2xl bg-black/20"
          style={{
            '-webkit-backdrop-filter': 'blur(40px)',
            'backdrop-filter': 'blur(40px)',
          }}
        />

        <div
          class={`relative w-full ${maxWidthClasses[props.maxWidth || 'md']} animate-in zoom-in-95 duration-300`}
          onClick={handleModalClick}
        >
          <div
            class="bg-white/95 backdrop-blur-3xl rounded-xl shadow-2xl overflow-hidden border border-white/20 p-2"
            style={{
              'box-shadow': '0 20px 60px 0 rgba(0, 0, 0, 0.3)',
              '-webkit-backdrop-filter': 'blur(60px)',
              'backdrop-filter': 'blur(60px)',
            }}
          >
            <Show when={props.title || props.showCloseButton !== false}>
              <div class="border-b border-gray-200/50">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <Show when={props.title}>
                      <h2 class="text-xl pl-2 font-semibold text-[#123b50]">
                        {props.title}
                      </h2>
                    </Show>
                    <Show when={props.subtitle}>
                      <p class="text-sm text-gray-500 mt-1">{props.subtitle}</p>
                    </Show>
                  </div>
                  <Show when={props.showCloseButton !== false}>
                    <CloseIcon onClick={props.onClose} />
                  </Show>
                </div>
              </div>
            </Show>

            <div class="p-2">{props.children}</div>
          </div>
        </div>
      </div>
    </Show>
  );
};

export default GlassModal;
